export const FEATURE_CODES = {
  TRANSPORT_MANAGEMENT: 'transport_management',
  TRANSPORT_CREW: 'transport_crew',
  FLEET_MANAGEMENT: 'fleet_management',
  WORKFORCE_MANAGEMENT: 'workforce_management',
  ADMIN_TOOLS: 'admin_tools',
  ROUTE_PLANNING: 'route_planning',
  LIVE_TRACKING: 'live_tracking',
  AI_ASSISTANT: 'ai_assistant',
  TRACKGPS: 'trackgps',
  ECMR: 'ecmr',
  PROFITABILITY: 'profitability',
  LKW_INVOICE_EXTRACTION: 'lkw_extragere_factura',
  FREIGHT_FORWARDING: 'freight_forwarding',
  WHATSAPP_NOTIFICATIONS: 'whatsapp_notifications',
  CARGOTRACK: 'cargotrack',
  OPTIFLEET: 'optifleet',
  EFACTURA: 'efactura',
  ETRANSPORT: 'etransport',
  TRANSPORT_QUOTATIONS: 'transport_quotations',
};

export const FEATURE_LABELS = {
  [FEATURE_CODES.TRANSPORT_MANAGEMENT]: 'Management transporturi',
  [FEATURE_CODES.TRANSPORT_CREW]: 'Echipaj transport',
  [FEATURE_CODES.FLEET_MANAGEMENT]: 'Management flotă',
  [FEATURE_CODES.WORKFORCE_MANAGEMENT]: 'Management personal',
  [FEATURE_CODES.ADMIN_TOOLS]: 'Administrare',
  [FEATURE_CODES.ROUTE_PLANNING]: 'Planificare rută',
  [FEATURE_CODES.LIVE_TRACKING]: 'Urmărire live',
  [FEATURE_CODES.AI_ASSISTANT]: 'Asistent AI',
  [FEATURE_CODES.TRACKGPS]: 'TrackGPS',
  [FEATURE_CODES.ECMR]: 'eCMR',
  [FEATURE_CODES.PROFITABILITY]: 'Profitabilitate',
  [FEATURE_CODES.LKW_INVOICE_EXTRACTION]: 'Extragere facturi LKW WALTER',
  [FEATURE_CODES.FREIGHT_FORWARDING]: 'Casă de expediție',
  [FEATURE_CODES.WHATSAPP_NOTIFICATIONS]: 'Notificări WhatsApp',
  [FEATURE_CODES.CARGOTRACK]: 'CargoTrack',
  [FEATURE_CODES.OPTIFLEET]: 'Optifleet',
  [FEATURE_CODES.EFACTURA]: 'e-Factura',
  [FEATURE_CODES.ETRANSPORT]: 'e-Transport',
  [FEATURE_CODES.TRANSPORT_QUOTATIONS]: 'Cotații transport',
};

export const hasFeature = (features, code) => features?.[code] === true;

export const hasAllFeatures = (features, ...codes) => (
  codes.every((code) => hasFeature(features, code))
);

export const requiresProfitabilityRouteData = (features, transport = {}) => (
  hasFeature(features, FEATURE_CODES.PROFITABILITY)
  && transport?.execution_mode === 'own_fleet'
  && transport?.transport_type === 'international'
);

export const getFeatureUnavailableMessage = (code) => (
  `Feature-ul ${FEATURE_LABELS[code] || code} nu este activ pentru compania ta.`
);
